var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _mask, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayoutActionNeededIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9446,
    cy: 32.4446,
    r: 31.9446,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.292 45.3962H24.7087C20.3337 45.3962 17.417 43.2087 17.417 38.1045V27.8962C17.417 22.792 20.3337 20.6045 24.7087 20.6045H39.292C43.667 20.6045 46.5837 22.792 46.5837 27.8962V38.1045C46.5837 43.2087 43.667 45.3962 39.292 45.3962Z",
    stroke: "#1E247E",
    strokeWidth: 2.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 37.375C34.4162 37.375 36.375 35.4162 36.375 33C36.375 30.5838 34.4162 28.625 32 28.625C29.5838 28.625 27.625 30.5838 27.625 33C27.625 35.4162 29.5838 37.375 32 37.375Z",
    fill: "#DA867D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.417 28.6247H18.8753C23.2503 28.6247 24.7087 27.1663 24.7087 22.7913V21.333",
    stroke: "#1E247E",
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5837 28.6247H45.1253C40.7503 28.6247 39.292 27.1663 39.292 22.7913V21.333",
    stroke: "#1E247E",
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.417 37.375H18.8753C23.2503 37.375 24.7087 38.8333 24.7087 43.2083V44.6667",
    stroke: "#1E247E",
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5837 37.375H45.1253C40.7503 37.375 39.292 38.8333 39.292 43.2083V44.6667",
    stroke: "#1E247E",
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32 35C33.1046 35 34 34.1046 34 33C34 31.8954 33.1046 31 32 31C30.8954 31 30 31.8954 30 33C30 34.1046 30.8954 35 32 35Z",
    fill: "#F0C330"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_27535_35738",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0555 0.555153C38.3735 0.566129 44.5464 2.45037 49.7936 5.9696C55.0407 9.48884 59.1264 14.485 61.5341 20.3263C63.9418 26.1676 64.5632 32.5917 63.3199 38.7861C62.0765 44.9806 59.0242 50.6673 54.5489 55.1271L52.9871 53.5598C57.1525 49.409 59.9934 44.1162 61.1506 38.3507C62.3078 32.5853 61.7294 26.6062 59.4885 21.1694C57.2476 15.7327 53.4449 11.0826 48.5611 7.80713C43.6774 4.53165 37.9321 2.77792 32.0516 2.7677L32.0555 0.555153Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0555 0.555153C38.3735 0.566129 44.5464 2.45037 49.7936 5.9696C55.0407 9.48884 59.1264 14.485 61.5341 20.3263C63.9418 26.1676 64.5632 32.5917 63.3199 38.7861C62.0765 44.9806 59.0242 50.6673 54.5489 55.1271L52.9871 53.5598C57.1525 49.409 59.9934 44.1162 61.1506 38.3507C62.3078 32.5853 61.7294 26.6062 59.4885 21.1694C57.2476 15.7327 53.4449 11.0826 48.5611 7.80713C43.6774 4.53165 37.9321 2.77792 32.0516 2.7677L32.0555 0.555153Z",
    stroke: "#3876BB",
    strokeWidth: 8,
    mask: "url(#path-9-inside-1_27535_35738)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutActionNeededIcon);
export default __webpack_public_path__ + "static/media/PayoutActionNeededIcon.5f95e3d09453521a8f3bf4b760808af1.svg";
export { ForwardRef as ReactComponent };